<template>
  <div
    v-if="tutorial"
    class="woo-login-wrapper"
    :style="{ background: `#${tutorial.passcode_bg_color || 'fff'}` }"
  >
    <router-link to="/" class="woo-login-back">
      <v-icon
        :style="{
          color: `#${tutorial.passcode_font_color}` || 'black'
        }"
      > mdi-arrow-left
      </v-icon>
    </router-link>
    <div class="woo-login">
      <v-img
        :src="tutorial.passcode_image_url"
        :lazy-src="tutorial.passcode_image_url"
        aspect-ratio="1"
        class="woo-login-image"
      />
      <div
        :style="{
          color: `#${tutorial.passcode_font_color}` || 'black'
        }"
        class="woo-tutorial-disclaimer"
        v-text="tutorial.legal_disclaimer"
      />
      <span
        :style="{
          color: `#${tutorial.passcode_font_color}` || 'black'
        }"
      >
        {{passwordPrompt}}
      </span>
      <v-text-field
        v-model="passcode"
        type="text"
        name="input-10-1"
        label="Enter the password"
        :append-icon="loading ? 'mdi-loading' : 'mdi-arrow-right'"
        rounded
        outlined
        :autofocus="isNotMobile"
        solo
        class="woo-login-passcode"
        :error-messages="error"
        @click:append="validatePasscode"
        @keydown.enter="validatePasscode"
        :style="`--error-color: #${tutorial.passcode_error_text_color || 'ff5252'}`"
      />
      <contact-form :tutorial="this.tutorial" :isPasswordForm="true"/>
    </div>
  </div>
</template>
<script>
import Db from '@/helpers/Db';
import HelperMethods from '@/helpers/HelperMethods';
import lite from '../store/shortcake-lite';
import api from '@/helpers/api';
import ContactForm from '../components/forms/ContactForm.vue';

export default {
  name: 'LoginView',
  data() {
    return {
      tutorial: null,
      loading: false,
      passcode: '',
      error: '',
      isNotMobile: !HelperMethods.isMobile()
    };
  },
  computed: {
    tutorialTitle() {
      let query = this.$route.query.r.split('/');
      const tutorialTkIndex = query.findIndex(q => q === 'tutorial');
      return query[tutorialTkIndex + 1].split('?')[0];
    },
    passwordPrompt() {
      const id = this.tutorial?.id

      const liteVersion = lite.find(l => {
        return l.id === id || l.id_prod === id;
      });
      
      return liteVersion?.password_prompt || 
      `
      To start wooblin', type in the password that's on the back of the card in your kit.
      `;
    }
  },
  components: {ContactForm},
  watch: {
    passcode(newValue) {
      if (!newValue) {
        this.error = '';
      }
    },
  },
  async mounted() {
    this.tutorial = await Db.getTutorialBySlug(this.tutorialTitle) || {};

    if (!this.tutorial?.id) {
      this.$router.replace('/404');
      return;
    }

    window.scrollTo(0, 0);
  },
  methods: {
    async validatePasscode() {
      this.loading = true;

      // We should only ask for email if we can load Klaviyo and e-mail has not been provided yet
      const needsToProvideEmail = HelperMethods.isKlaviyoAvailable() && !window._learnq.isIdentified();

      const passcode = await api.validateTutorialPassword({
        code: this.passcode,
        id: this.tutorial.id,
        sku: this.tutorial.sku,
        tutorialPasscodes: this.tutorial.passcodes,
      });

      this.loading = false;

      const { valid, message, messageKey } = passcode;

      // We used to store redirect_urls in passcodes, but we're moving to the guide now
      // We will still support passcode level redirects and if one is set it will override
      // the tutorial one, but this should be an exception and will only be done in the DB
      // const redirectUrl = tutorial.redirect_url || passcode.redirect_url;

      const dataLayerEvent = {
        event: 'w_kit_code_validation',
        code: this.passcode,
        code_state: messageKey,
      }

      // Password doesn't match
      if (!valid) {
        this.error = message || 'Hmm, that’s not right. Check the password and try again.';

        if (this.passcode.length >= 4) {
          window.dataLayer.push({
            status: 'incorrect',
            ...dataLayerEvent
          });
        }

        return;
      }

      window.dataLayer.push({
        status: 'correct',
        ...dataLayerEvent
      });

      HelperMethods.logIn({
        slug: this.tutorialTitle,
        passcode,
      })

      if (needsToProvideEmail) {
        // Navigate to email prompt - don't use router navigation, otherwise Klaviyo won't load
        window.location = `${window.location.origin}/email?r=${this.$route.query.r}`;
      } else {
        this.$router.push(this.$route.query.r);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.woo-tutorial-disclaimer {
  text-align: center;
  padding: 12px;
  font-size: 12px;
}

.woo-login {
  max-width: 20rem;
  margin: auto;
  top: 88px;
  padding-top: 22px;
  padding-bottom: 2rem;
}

.woo-login-back {
  top: 40px;
  left: 30px;
  position: absolute;
  z-index: 1000;
}

.woo-login-wrapper {
  height: 100%;
}

.woo-login-passcode {
  margin-top: 1rem !important;
}

.woo-login-passcode-recovery {
  color: #000;
  text-decoration: underline;
  font-size: 0.875rem;
  font-weight: 700;
  text-align: center;
}
</style>
<style lang="scss">
.woo-login {
  .error--text .v-messages__wrapper .v-messages__message {
    color: var(--error-color) !important;
  }
}
</style>
